import { useLocalStorage } from "usehooks-ts";
import { LoginData } from '../Types'

export default function Login(props: { tryLogin: any, logout: any, password: string, setMessage: any }) {
  const [value, setValue, removeValue] = useLocalStorage("test-key", 0);

  if (props.password && props.password.length > 0) {
    return <div className="Flex">
      <button onClick={e => { props.logout() }}>Logga ut</button>
    </div>
  }

  return (
    <div className="Flex">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          const form: HTMLFormElement = e.target as HTMLFormElement;
          const formData = new FormData(form);
          const formJson = Object.fromEntries(formData.entries());
          const loginData: LoginData = formJson as LoginData;
          console.log(loginData.password);
          if (loginData.password === '') {
            props.setMessage("Du behöver ange ett lösenord för projektet")
          } else {
            props.tryLogin(loginData.password);
          }
        }}
      >
        <input id="password" name="password" type="password" placeholder="Lösenord" />
        <button type="submit">Logga in</button>
      </form>
    </div>
  );
}
